module.exports = __webpack_public_path__ + "img/delete-red.e7af52e6.svg";